import React from 'react';

function LandingPage({ onGetStarted }) {
  
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="landing-page" style={{ 
      backgroundColor: '#05070A', 
      color: '#FFFFFF', 
      minHeight: '100vh', 
      display: 'flex', 
      flexDirection: 'column', 
      fontFamily: "'Plus Jakarta Sans', sans-serif",
      position: 'relative',
      overflowX: 'hidden',
      boxSizing: 'border-box'
    }}>
      
      {/* Fixed Deep Black Transparent Navbar */}
      <nav style={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center', 
        padding: '15px 50px', 
        borderBottom: '1px solid rgba(255, 255, 255, 0.08)', 
        position: 'fixed', 
        top: 0, 
        left: 0,
        right: 0,
        backgroundColor: 'rgba(5, 7, 10, 0.95)', 
        backdropFilter: 'blur(14px)',
        zIndex: 1000, 
        boxShadow: '0 4px 25px rgba(0,0,0,0.5)',
        flexWrap: 'wrap',
        gap: '15px'
      }}>
        {/* Navbar Logo using the exact uploaded image banner */}
        <div className="landing-logo" style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }} onClick={() => scrollToSection('home')}>
          <img 
            src="/logo1.png" 
            alt="VYODHA Institutional Logo" 
            style={{ height: '42px', width: 'auto', objectFit: 'contain',  }} 
          />
        </div>

        {/* Center Navigation Links */}
        <div style={{ display: 'flex', gap: '25px', alignItems: 'center', flexWrap: 'wrap' }}>
          <span onClick={() => scrollToSection('home')} style={{ color: '#F3F4F6', fontSize: '14px', fontWeight: '600', cursor: 'pointer' }} onMouseEnter={(e) => e.target.style.color = '#D4AF37'} onMouseLeave={(e) => e.target.style.color = '#F3F4F6'}>Home</span>
          <span onClick={() => scrollToSection('features')} style={{ color: '#F3F4F6', fontSize: '14px', fontWeight: '600', cursor: 'pointer' }} onMouseEnter={(e) => e.target.style.color = '#D4AF37'} onMouseLeave={(e) => e.target.style.color = '#F3F4F6'}>Features</span>
          <span onClick={() => scrollToSection('about')} style={{ color: '#F3F4F6', fontSize: '14px', fontWeight: '600', cursor: 'pointer' }} onMouseEnter={(e) => e.target.style.color = '#D4AF37'} onMouseLeave={(e) => e.target.style.color = '#F3F4F6'}>About Us</span>
          <span onClick={() => scrollToSection('contact')} style={{ color: '#F3F4F6', fontSize: '14px', fontWeight: '600', cursor: 'pointer' }} onMouseEnter={(e) => e.target.style.color = '#D4AF37'} onMouseLeave={(e) => e.target.style.color = '#F3F4F6'}>Contact Us</span>
        </div>
        
        {/* Auth Action Buttons */}
        <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
          <button onClick={onGetStarted} style={{ backgroundColor: 'transparent', color: '#F3F4F6', border: '1px solid rgba(255, 255, 255, 0.3)', padding: '9px 18px', borderRadius: '8px', fontWeight: '600', cursor: 'pointer', fontSize: '13px' }}>
            Sign In
          </button>
          <button onClick={onGetStarted} style={{ backgroundColor: '#D4AF37', color: '#000', border: 'none', padding: '9px 20px', borderRadius: '8px', fontWeight: '700', cursor: 'pointer', fontSize: '13px', boxShadow: '0 4px 15px rgba(212, 175, 55, 0.35)' }}>
            Sign Up 🚀
          </button>
        </div>
      </nav>

      {/* Hero Section */}
      <header id="home" style={{ 
        padding: '160px 20px 100px 20px', 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'space-between',
        minHeight: '85vh',
        maxWidth: '1350px', 
        margin: '0 auto',
        width: '100%',
        boxSizing: 'border-box',
        gap: '40px',
        flexWrap: 'wrap'
      }}>
        {/* Left Side: Text Content */}
        <div style={{ flex: '1 1 500px', textAlign: 'left', zIndex: 2 }}>
          <span style={{ 
            backgroundColor: 'rgba(212, 175, 55, 0.15)', 
            color: '#D4AF37', 
            padding: '6px 16px', 
            borderRadius: '30px', 
            fontSize: '11px', 
            fontWeight: '800', 
            border: '1px solid rgba(212, 175, 55, 0.5)', 
            letterSpacing: '1.5px', 
            textTransform: 'uppercase',
            display: 'inline-block',
            marginBottom: '20px',
            boxShadow: '0 0 20px rgba(212, 175, 55, 0.2)'
          }}>
            🌟 THE ULTIMATE INSTITUTIONAL TRADING ECOSYSTEM
          </span>
          
          <h1 style={{ fontFamily: "'Cinzel', serif", fontSize: 'clamp(36px, 5vw, 56px)', fontWeight: '900', margin: '0 0 20px 0', lineHeight: '1.15', color: '#FFFFFF' }}>
            MASTER THE MARKET. <br /><span style={{ color: '#D4AF37' }}>OWN YOUR FUTURE.</span>
          </h1>
          
          <p style={{ color: '#9CA3AF', fontSize: '16px', maxWidth: '600px', marginBottom: '35px', lineHeight: '1.7' }}>
            Vyodha integrates multi-broker execution, AI risk management, and live institutional data into a singular, high-performance workstation built for serious traders.
          </p>

          <div style={{ display: 'flex', gap: '15px', flexWrap: 'wrap' }}>
            <button onClick={onGetStarted} style={{ 
              backgroundColor: '#D4AF37', 
              color: '#000', 
              border: 'none', 
              padding: '15px 35px', 
              borderRadius: '10px', 
              fontSize: '15px', 
              fontWeight: 'bold', 
              cursor: 'pointer', 
              boxShadow: '0 10px 30px rgba(212, 175, 55, 0.4)'
            }}>
              Get Started Free 🚀
            </button>
            <button onClick={() => scrollToSection('features')} style={{ 
              backgroundColor: 'transparent', 
              color: '#FFFFFF', 
              border: '1px solid rgba(212, 175, 55, 0.5)', 
              padding: '15px 30px', 
              borderRadius: '10px', 
              fontSize: '15px', 
              fontWeight: 'bold', 
              cursor: 'pointer'
            }}>
              Explore Modules ⚡
            </button>
          </div>
        </div>

        {/* Right Side: Animated Floating Official Logo Banner */}
        <div style={{ 
          flex: '1 1 450px', 
          display: 'flex', 
          justifyContent: 'center',
          alignItems: 'center',
          position: 'relative',
          width: '100%'
        }}>
          <div style={{
            position: 'absolute',
            width: '300px',
            height: '300px',
            background: 'radial-gradient(circle, rgba(212, 175, 55, 0.3) 0%, rgba(0,0,0,0) 70%)',
            filter: 'blur(50px)',
            zIndex: 1
          }}></div>

          <div className="floating-logo" style={{ 
            width: '100%', 
            maxWidth: '500px',
            borderRadius: '20px',
            overflow: 'hidden',
            boxShadow: '0 25px 60px rgba(212, 175, 55, 0.25)',
            border: '2px solid rgba(212, 175, 55, 0.6)',
            backgroundColor: '#111827',
            zIndex: 2
          }}>
            <img 
              src="/logo-banner.png" 
              alt="Vyodha Institutional Logo" 
              style={{ width: '100%', height: 'auto', display: 'block', objectFit: 'cover' }} 
            />
          </div>
        </div>
      </header>

      {/* Platform Demo Section with Multiple Videos */}
      <section style={{ padding: '80px 20px', backgroundColor: '#0B0F19', borderTop: '1px solid rgba(212, 175, 55, 0.2)' }}>
        <div style={{ maxWidth: '1300px', margin: '0 auto', textAlign: 'center' }}>
          <span style={{ color: '#D4AF37', fontSize: '13px', fontWeight: 'bold', textTransform: 'uppercase', letterSpacing: '1.2px' }}>🎥 PLATFORM WALKTHROUGH TEASERS</span>
          <h2 style={{ fontSize: 'clamp(28px, 4vw, 38px)', fontFamily: "'Cinzel', serif", margin: '12px 0 20px 0', color: '#FFFFFF' }}>See How Vyodha Works in Action</h2>
          <p style={{ color: '#9CA3AF', fontSize: '16px', maxWidth: '750px', margin: '0 auto 40px auto', lineHeight: '1.7' }}>
            Explore our discipline modules, automated trailing stop-losses, and live execution terminals through these demonstration clips.
          </p>

          <div style={{ 
            display: 'grid', 
            gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))', 
            gap: '30px', 
            alignItems: 'center' 
          }}>
            
            <div style={{ 
              borderRadius: '16px', 
              border: '2px solid rgba(212, 175, 55, 0.4)', 
              boxShadow: '0 15px 35px rgba(0,0,0,0.5)', 
              overflow: 'hidden', 
              backgroundColor: '#000' 
            }}>
              <video controls autoPlay loop muted playsInline style={{ width: '100%', height: 'auto', display: 'block', maxHeight: '280px', objectFit: 'cover' }}>
                <source src="/finaltuch.mp4" type="video/mp4" />
                Your browser does not support the video tag.
              </video>
              <div style={{ padding: '15px', textAlign: 'left', backgroundColor: '#111827' }}>
                <h4 style={{ color: '#D4AF37', fontSize: '16px', margin: '0 0 5px 0', fontFamily: "'Cinzel', serif" }}>FOMO vs Discipline Setup</h4>
                <p style={{ color: '#9CA3AF', fontSize: '13px', margin: 0 }}>Institutional approach to avoiding emotional entry.</p>
              </div>
            </div>

            <div style={{ 
              borderRadius: '16px', 
              border: '2px solid rgba(212, 175, 55, 0.4)', 
              boxShadow: '0 15px 35px rgba(0,0,0,0.5)', 
              overflow: 'hidden', 
              backgroundColor: '#000' 
            }}>
              <video controls autoPlay loop muted playsInline style={{ width: '100%', height: 'auto', display: 'block', maxHeight: '280px', objectFit: 'cover' }}>
                <source src="/advertisement.mp4" type="video/mp4" />
                Your browser does not support the video tag.
              </video>
              <div style={{ padding: '15px', textAlign: 'left', backgroundColor: '#111827' }}>
                <h4 style={{ color: '#D4AF37', fontSize: '16px', margin: '0 0 5px 0', fontFamily: "'Cinzel', serif" }}>AI Trailing Stop-Loss Bot</h4>
                <p style={{ color: '#9CA3AF', fontSize: '13px', margin: 0 }}>Automated risk protection and profit locking.</p>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* Features Grid */}
      <section id="features" style={{ padding: '80px 20px', maxWidth: '1300px', margin: '0 auto', width: '100%', boxSizing: 'border-box', backgroundColor: '#05070A' }}>
        <div style={{ textAlign: 'center', marginBottom: '50px' }}>
          <h2 style={{ fontSize: 'clamp(28px, 4vw, 38px)', fontFamily: "'Cinzel', serif", marginBottom: '12px', color: '#FFFFFF' }}>Engineered for Elite Performance</h2>
          <p style={{ color: '#9CA3AF', fontSize: '16px' }}>Explore the powerful modules integrated directly into your workspace.</p>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '25px' }}>
          {[
            { icon: "🤖", title: "AI Chart Vision Assistant", desc: "Upload any chart screenshot to get instant AI analysis on support, resistance, entry points, stop-losses, and target levels." },
            { icon: "🤖⚡", title: "AI Trailing Stop-Loss Bot", desc: "Automate profit protection as market prices move in your favor, locking in gains securely without manual tracking." },
            { icon: "🗺️", title: "Live Sector Heatmap", desc: "Track real-time momentum across Banking, IT, Auto, and Energy sectors with clean color-coded performance indicators." },
            { icon: "🧮", title: "Risk & Position Calculator", desc: "Protect capital like a fund manager by calculating exact lot sizes and risk exposure before executing trades." },
            { icon: "💬", title: "Social Trading Room", desc: "Connect with global traders, share live setups, discuss market sentiment, and view performance badges." },
            { icon: "🔌", title: "Multi-Broker API Integration", desc: "Seamlessly link your Zerodha, Upstox, Binance, or Angel One accounts for secure order routing." }
          ].map((feat, i) => (
            <div key={i} style={{ backgroundColor: '#111827', border: '1px solid rgba(212, 175, 55, 0.2)', padding: '35px 30px', borderRadius: '16px', boxShadow: '0 12px 35px rgba(0,0,0,0.3)', transition: 'all 0.3s ease' }}
              onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateY(-8px)'; e.currentTarget.style.borderColor = '#D4AF37'; }}
              onMouseLeave={(e) => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.borderColor = 'rgba(212, 175, 55, 0.2)'; }}
            >
              <div style={{ fontSize: '32px', marginBottom: '15px' }}>{feat.icon}</div>
              <h3 style={{ fontSize: '18px', color: '#D4AF37', marginBottom: '10px', fontFamily: "'Cinzel', serif" }}>{feat.title}</h3>
              <p style={{ color: '#9CA3AF', fontSize: '14px', lineHeight: '1.6', margin: 0 }}>{feat.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* About Us Section */}
      <section id="about" style={{ padding: '80px 20px', backgroundColor: '#0B0F19', borderTop: '1px solid rgba(212, 175, 55, 0.2)' }}>
        <div style={{ maxWidth: '900px', margin: '0 auto', textAlign: 'center' }}>
          <span style={{ color: '#D4AF37', fontSize: '13px', fontWeight: 'bold', textTransform: 'uppercase', letterSpacing: '1.2px' }}>📖 WHO WE ARE</span>
          <h2 style={{ fontSize: 'clamp(28px, 4vw, 38px)', fontFamily: "'Cinzel', serif", margin: '12px 0 20px 0', color: '#FFFFFF' }}>About Vyodha Terminal</h2>
          <p style={{ color: '#9CA3AF', fontSize: '16px', lineHeight: '1.8', margin: 0 }}>
            Vyodha was founded with a single vision: to bridge the gap between retail traders and institutional-grade financial technology. We believe that discipline, automated risk controls, and advanced artificial intelligence are the cornerstones of consistent market mastery.
          </p>
        </div>
      </section>

      {/* Contact Us Section */}
      <section id="contact" style={{ padding: '80px 20px', backgroundColor: '#05070A', borderTop: '1px solid rgba(212, 175, 55, 0.2)' }}>
        <div style={{ maxWidth: '800px', margin: '0 auto', textAlign: 'center' }}>
          <span style={{ color: '#D4AF37', fontSize: '13px', fontWeight: 'bold', textTransform: 'uppercase', letterSpacing: '1.2px' }}>📬 GET IN TOUCH</span>
          <h2 style={{ fontSize: 'clamp(28px, 4vw, 38px)', fontFamily: "'Cinzel', serif", margin: '12px 0 15px 0', color: '#FFFFFF' }}>Contact Vyodha Support</h2>
          <p style={{ color: '#9CA3AF', fontSize: '15px', marginBottom: '35px' }}>Have questions about broker APIs, subscription plans, or institutional access? Drop us a message below.</p>

          <form onSubmit={(e) => { e.preventDefault(); alert("Message sent successfully! Our support team will get back to you shortly."); }} style={{ display: 'flex', flexDirection: 'column', gap: '15px', textAlign: 'left' }}>
            <div style={{ display: 'flex', gap: '15px', flexWrap: 'wrap' }}>
              <input type="text" placeholder="Your Name" required style={{ flex: '1 1 250px', padding: '14px 16px', borderRadius: '10px', border: '1px solid rgba(212, 175, 55, 0.3)', backgroundColor: '#111827', color: '#FFFFFF', outline: 'none', fontSize: '14px' }} />
              <input type="email" placeholder="Your Email ID" required style={{ flex: '1 1 250px', padding: '14px 16px', borderRadius: '10px', border: '1px solid rgba(212, 175, 55, 0.3)', backgroundColor: '#111827', color: '#FFFFFF', outline: 'none', fontSize: '14px' }} />
            </div>
            <textarea placeholder="Your Message or Query..." rows="4" required style={{ width: '100%', padding: '14px 16px', borderRadius: '10px', border: '1px solid rgba(212, 175, 55, 0.3)', backgroundColor: '#111827', color: '#FFFFFF', outline: 'none', boxSizing: 'border-box', fontSize: '14px' }}></textarea>
            <button type="submit" style={{ backgroundColor: '#D4AF37', color: '#000', border: 'none', padding: '15px', borderRadius: '10px', fontWeight: 'bold', cursor: 'pointer', fontSize: '15px', boxShadow: '0 6px 20px rgba(212, 175, 55, 0.4)' }}>
              Send Message 🚀
            </button>
          </form>
        </div>
      </section>

      {/* Professional Dark Footer */}
      <footer style={{ 
        backgroundColor: '#030508', 
        color: '#9CA3AF', 
        padding: '60px 20px 30px 20px', 
        borderTop: '1px solid rgba(212, 175, 55, 0.2)',
        marginTop: 'auto'
      }}>
        <div style={{ maxWidth: '1300px', margin: '0 auto', display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: '40px', marginBottom: '40px' }}>
          
          <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <img src="/logo1.png" alt="Logo" style={{ height: '28px', width: 'auto', objectFit: 'contain' }} />
            </div>
            <p style={{ fontSize: '13px', lineHeight: '1.6', margin: 0, color: '#9CA3AF' }}>
              Vyodha is the ultimate institutional multiverse trading ecosystem engineered for precision execution and elite discipline.
            </p>
          </div>

          <div>
            <h4 style={{ color: '#FFFFFF', fontSize: '15px', fontFamily: "'Cinzel', serif", marginBottom: '15px' }}>Quick Navigation</h4>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '10px', fontSize: '13px' }}>
              <li><span style={{ cursor: 'pointer' }} onClick={() => scrollToSection('home')}>Home</span></li>
              <li><span style={{ cursor: 'pointer' }} onClick={() => scrollToSection('features')}>Features Details</span></li>
              <li><span style={{ cursor: 'pointer' }} onClick={() => scrollToSection('about')}>About Us</span></li>
              <li><span style={{ cursor: 'pointer' }} onClick={() => scrollToSection('contact')}>Contact Support</span></li>
            </ul>
          </div>

          <div>
            <h4 style={{ color: '#FFFFFF', fontSize: '15px', fontFamily: "'Cinzel', serif", marginBottom: '15px' }}>Terminal Modules</h4>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '10px', fontSize: '13px', color: '#9CA3AF' }}>
              <li>⚡ AI Trailing Stop-Loss Bot</li>
              <li>📊 NSE Standard Option Chain</li>
              <li>🛡️ Risk & Position Sizing Calc</li>
              <li>💬 Social Trading Community</li>
            </ul>
          </div>

          {/* Social Media Links */}
          <div>
            <h4 style={{ color: '#FFFFFF', fontSize: '15px', fontFamily: "'Cinzel', serif", marginBottom: '15px' }}>Connect With Us</h4>
            <p style={{ fontSize: '13px', marginBottom: '10px', color: '#9CA3AF' }}>Join our official channels.</p>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', fontSize: '13px' }}>
              <a href="https://telegram.org" target="_blank" rel="noreferrer" style={{ color: '#0088cc', textDecoration: 'none', fontWeight: '600' }}>✈️ Telegram Community</a>
              <a href="https://youtube.com" target="_blank" rel="noreferrer" style={{ color: '#FF0000', textDecoration: 'none', fontWeight: '600' }}>▶ YouTube Channel</a>
              <a href="https://twitter.com" target="_blank" rel="noreferrer" style={{ color: '#FFFFFF', textDecoration: 'none', fontWeight: '600' }}>𝕏 Twitter / X Feed</a>
            </div>
          </div>

        </div>

        <div style={{ maxWidth: '1300px', margin: '0 auto', borderTop: '1px solid rgba(255, 255, 255, 0.08)', paddingTop: '20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '10px', fontSize: '12px' }}>
          <span>© 2026 VYODHA TERMINAL. All Rights Reserved.</span>
          <span style={{ color: '#D4AF37' }}>Discipline. Strategy. Victory. 🚀</span>
        </div>
      </footer>

      {/* CSS Animations & Media Queries */}
      <style>{`
        @keyframes floatLogo {
          0% { transform: translateY(0px); }
          50% { transform: translateY(-8px); }
          100% { transform: translateY(0px); }
        }
        .floating-logo {
          animation: floatLogo 4s ease-in-out infinite;
        }
        @media (max-width: 768px) {
          nav {
            padding: 15px 20px !important;
          }
          header#home {
            padding: 140px 20px 80px 20px !important;
            text-align: center;
          }
        }
      `}</style>

    </div>
  );
}

export default LandingPage;